<template>
    <div class="help-tip">
        <i class="glyphicon glyphicon-question-sign" @click="onClicked()"></i>
        <div v-if="visible">
            <div :class="'help-tip-text ' + size + ' ' + side">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      size: {
        default: "small"
      },
      side: {
        default: "right"
      }
    },
    data() {
      return {
        visible: false,
        clicked: false
      }
    },
    methods: {
      onClicked() {
        this.clicked = true;
        this.visible = !this.visible;
      },
      onUnhandledClick() {
        if (!this.clicked) {
          this.visible = false
        }

        this.clicked = false
      }
    },
    events: {
      unhandledClick() {
        if (!this.clicked) {
          this.visible = false;
        }

        this.clicked = false;
      }
    },
    mounted() {
      this.$root.$on('unhandledClick', this.onUnhandledClick);
    }
  }
</script>
